import { generateDatesBeetweenPeriod } from "../../utils/FormatDate";
import PeriodDuration from "../PeriodDuration";

const periodChoice = "month";
const { start, end } = generateDatesBeetweenPeriod(new Date(), PeriodDuration[periodChoice]);
const last = generateDatesBeetweenPeriod(start, PeriodDuration[periodChoice]);

const AnalyticsState = {
    firstPeriod: {
        date_start: start,
        date_end: end,
    },
    secondPeriod: {
        date_start: last.start,
        date_end: last.end,
    },
    periodChoice: periodChoice,
    channel_type_id: null,
    channel_id: null,
    redirection_id: null,
    metrics_id: null,
    condition_id: null,
    content: "",
    analytics: {
        average_duration_of_conversations: {},
        average_duration_of_conversations_stats : {},

        average_number_of_messages: {},
        average_number_of_messages_stats : {},
        
        number_of_conversations: {},
        number_of_conversations_stats : {},

        number_of_message_per_day: {},

        number_of_messages: {},
        number_of_messages_stats: {},

        number_of_users: {},
        number_of_users_stats: {},

        number_of_minutes_total : {},
        number_of_minutes_total_stats : {},

        number_of_minutes_bot : {},
        number_of_minutes_bot_stats : {},
        
        number_of_minutes_human : {},
        number_of_minutes_human_stats : {}
    },
    metrics: {
        conditions: [],
        redirections: [],
    },
    channels: [],
    view: "dates",
    peakActivity: [],
    redirectionActivity: [],
};

export default AnalyticsState;
